import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

import { Markdown } from ".";

import { SmallText, Heading2, Heading4 } from "../styleguide";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 20,
    },
    kickerStyle: {
        color: "#838a92",
        marginBottom: 5,
    },
    headlineStyle: {
        lineHeight: 1.33,
        marginTop: 22,
        marginBottom: 7,
    },
    headingRelative: {
        position: "relative",
    },
    descriptionStyle: {
        marginBottom: 1,
    },
});

const IntroSection = ({
    kicker,
    title,
    headline,
    description,
    children,
    classes: { containerStyle, kickerStyle, headlineStyle, headingFlex },
}) => (
    <div
        style={{
            padding: `${NAVIGATION_HEIGHT + 31}px 36px 16px 36px`,
            backgroundColor: "#fff",
        }}
        className="intro-section-wrapper"
    >
        <Grid container spacing={0} className={`${containerStyle} intro-section-container`}>
            <Grid item xs>
                {children}
                <SmallText className={`${kickerStyle} intro-section-kicker`}>{kicker}</SmallText>
                <Heading2>{title}</Heading2>
                <Heading4 className={headlineStyle}>{headline}</Heading4>
                <Grid item xs md={8} className="markdown-description-container">
                    <Markdown source={description} />
                </Grid>
            </Grid>
        </Grid>
    </div>
);

IntroSection.propTypes = {
    kicker: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntroSection);



// WEBPACK FOOTER //
// ./src/components/IntroSection.js